import TextAusrichtung from './enums/TextAusrichtung';
import { normalizeHexColor } from '@src/utils/normalizeHexColor';

export default class DOTClientElementLayout {
  /**
   * @param {*} layout
   * @param {*} ueberschriftSchriftgroesse
   * @param {*} textSchriftgroesse
   * @param {*} ueberschriftSchriftart
   * @param {*} textSchriftart
   * @param {*} abstandOben
   * @param {*} abstandUnten
   * @param {*} abstandRechts
   * @param {*} abstandLinks
   * @param {*} abstandAbsatz
   * @param {*} textAusrichtung
   * @param {*} abstandVorUeberschrift
   * @param {*} columnGap
   * @param {*} textSchriftFarbe
   * @param {*} ueberschriftSchriftFarbe
   * @param {*} ueberschriftHintergrundFarbe
   * @param {*} ueberschriftAbstand
   * @param {*} ueberschriftUnterstrichFarbe
   * @param {*} ueberschriftUnterstrichStaerke
   * @param {*} ueberschriftAusrichtung
   * @param {*} ueberschriftSchrifteffekte
   *
   * @param {*} logo
   * @param {*} breiteLogo
   * @param {*} platzierungLogo
   * @param {*} kopfzeileText
   * @param {*} kopfzeileTextGroesse
   * @param {*} kopfzeileTextFarbe
   * @param {*} kopfzeilePositionierung
   *
   * @param {*} formularHintergrundfarbe
   * @param {*} formularRandPosition
   * @param {*} formularRandStaerke
   * @param {*} formularRandRadius
   * @param {*} formularRandFarbe
   * @param {*} formElementSpacing
   *
   * @param {*} tabelleUmrandung
   * @param {*} tabelleUmrandungStaerke
   * @param {*} tabelleUmrandungFarbe
   * @param {*} tabelleHintergrundFarbe
   * @param {*} tabelleKopfzeileEffekte
   * @param {*} tabelleKopfzeileSchriftFarbe
   * @param {*} tabelleKopfHintergrundFarbe
   *
   * @param {*} fusszeileSpaltenlayout
   * @param {*} fusszeileTexte
   * @param {*} footerContent
   * @param {*} fusszeileNummerierung
   * @param {*} fusszeileTexteGroesse
   * @param {*} fusszeileTexteFarbe
   */
  constructor(
    layout,
    ueberschriftSchriftgroesse,
    textSchriftgroesse,
    ueberschriftSchriftart,
    textSchriftart,
    abstandOben,
    abstandUnten,
    abstandRechts,
    abstandLinks,
    abstandAbsatz,
    textAusrichtung,
    abstandVorUeberschrift,
    columnGap,
    textSchriftFarbe,
    ueberschriftSchriftFarbe,
    ueberschriftHintergrundFarbe,
    ueberschriftAbstand,
    ueberschriftUnterstrichFarbe,
    ueberschriftUnterstrichStaerke,
    ueberschriftAusrichtung,
    ueberschriftSchrifteffekte,

    logo,
    breiteLogo,
    platzierungLogo,
    kopfzeileText,
    kopfzeileTextGroesse,
    kopfzeileTextFarbe,
    kopfzeilePositionierung,

    formularHintergrundfarbe,
    formularRandPosition,
    formularRandStaerke,
    formularRandRadius,
    formularRandFarbe,
    formElementSpacing,

    tabelleUmrandung,
    tabelleUmrandungStaerke,
    tabelleUmrandungFarbe,
    tabelleHintergrundFarbe,
    tabelleKopfzeileEffekte,
    tabelleKopfzeileSchriftFarbe,
    tabelleKopfHintergrundFarbe,

    fusszeileSpaltenlayout,
    fusszeileTexte,
    footerContent,
    fusszeileNummerierung,
    fusszeileTexteGroesse,
    fusszeileTexteFarbe
  ) {
    this.layout = layout;
    this.ueberschriftSchriftgroesse = ueberschriftSchriftgroesse;
    this.textSchriftgroesse = textSchriftgroesse;
    this.ueberschriftSchriftart = ueberschriftSchriftart;
    this.textSchriftart = textSchriftart;
    this.abstandOben = abstandOben;
    this.abstandUnten = abstandUnten;
    this.abstandRechts = abstandRechts;
    this.abstandLinks = abstandLinks;
    this.abstandAbsatz = abstandAbsatz;
    this.textAusrichtung = textAusrichtung;
    this.abstandVorUeberschrift = abstandVorUeberschrift;
    this.columnGap = columnGap;

    // prevent shorthand colors from reaching the API
    this.textSchriftFarbe = normalizeHexColor(textSchriftFarbe);
    this.ueberschriftSchriftFarbe = normalizeHexColor(ueberschriftSchriftFarbe);
    this.ueberschriftHintergrundFarbe = normalizeHexColor(ueberschriftHintergrundFarbe);
    this.ueberschriftAbstand = ueberschriftAbstand;
    this.ueberschriftUnterstrichFarbe = normalizeHexColor(ueberschriftUnterstrichFarbe);
    this.ueberschriftUnterstrichStaerke = ueberschriftUnterstrichStaerke;
    this.ueberschriftAusrichtung = ueberschriftAusrichtung;
    this.ueberschriftSchrifteffekte = ueberschriftSchrifteffekte;

    this.logo = logo;
    this.breiteLogo = breiteLogo;
    this.platzierungLogo = platzierungLogo;
    this.kopfzeileText = kopfzeileText;
    this.kopfzeileTextGroesse = kopfzeileTextGroesse;
    this.kopfzeileTextFarbe = normalizeHexColor(kopfzeileTextFarbe);
    this.kopfzeilePositionierung = kopfzeilePositionierung;

    this.formularHintergrundfarbe = normalizeHexColor(formularHintergrundfarbe);
    this.formularRandPosition = formularRandPosition;
    this.formularRandStaerke = formularRandStaerke;
    this.formularRandRadius = formularRandRadius;
    this.formularRandFarbe = normalizeHexColor(formularRandFarbe);
    this.formElementSpacing = formElementSpacing;

    this.tabelleUmrandung = tabelleUmrandung;
    this.tabelleUmrandungStaerke = tabelleUmrandungStaerke;
    this.tabelleUmrandungFarbe = normalizeHexColor(tabelleUmrandungFarbe);
    this.tabelleHintergrundFarbe = normalizeHexColor(tabelleHintergrundFarbe);
    this.tabelleKopfzeileEffekte = tabelleKopfzeileEffekte;
    this.tabelleKopfzeileSchriftFarbe = normalizeHexColor(tabelleKopfzeileSchriftFarbe);
    this.tabelleKopfHintergrundFarbe = normalizeHexColor(tabelleKopfHintergrundFarbe);

    this.fusszeileSpaltenlayout = fusszeileSpaltenlayout;
    this.fusszeileTexte = fusszeileTexte;
    this.footerContent = footerContent;
    this.fusszeileNummerierung = fusszeileNummerierung;
    this.fusszeileTexteGroesse = fusszeileTexteGroesse;
    this.fusszeileTexteFarbe = normalizeHexColor(fusszeileTexteFarbe);
  }

  static fromJson(json) {
    const {
      layout,
      ueberschriftSchriftgroesse,
      textSchriftgroesse,
      ueberschriftSchriftart,
      textSchriftart,
      abstandAbsatz,
      // keep old payloads on linksbuendig when the field is not present
      textAusrichtung = TextAusrichtung.LINKSBUENDIG,
      abstandVorUeberschrift,
      columnGap,
      textSchriftFarbe,
      ueberschriftSchriftFarbe,
      ueberschriftHintergrundFarbe,
      ueberschriftAbstand,
      ueberschriftUnterstrichFarbe,
      ueberschriftUnterstrichStaerke,
      ueberschriftAusrichtung,
      ueberschriftSchrifteffekte,

      logo,
      breiteLogo,
      platzierungLogo,
      kopfzeileText,
      kopfzeileTextGroesse,
      kopfzeileTextFarbe,
      kopfzeilePositionierung,
      padding,

      formularHintergrundfarbe,
      formularRandPosition,
      formularRandStaerke,
      formularRandRadius,
      formularRandFarbe,
      formElementSpacing,

      tabelleUmrandung,
      tabelleUmrandungStaerke,
      tabelleUmrandungFarbe,
      tabelleHintergrundFarbe,
      tabelleKopfzeileEffekte,
      tabelleKopfzeileSchriftFarbe,
      tabelleKopfHintergrundFarbe,

      fusszeileSpaltenlayout,
      fusszeileTexte,
      footerContent,
      fusszeileNummerierung,
      fusszeileTexteGroesse,
      fusszeileTexteFarbe
    } = json;

    const abstandOben = padding?.top ?? json.abstandOben;
    const abstandUnten = padding?.bottom ?? json.abstandUnten;
    const abstandRechts = padding?.right ?? json.abstandRechts;
    const abstandLinks = padding?.left ?? json.abstandLinks;

    return new DOTClientElementLayout(
      layout,
      ueberschriftSchriftgroesse,
      textSchriftgroesse,
      ueberschriftSchriftart,
      textSchriftart,
      abstandOben,
      abstandUnten,
      abstandRechts,
      abstandLinks,
      abstandAbsatz,
      textAusrichtung,
      abstandVorUeberschrift,
      columnGap,
      textSchriftFarbe,
      ueberschriftSchriftFarbe,
      ueberschriftHintergrundFarbe,
      ueberschriftAbstand,
      ueberschriftUnterstrichFarbe,
      ueberschriftUnterstrichStaerke,
      ueberschriftAusrichtung,
      ueberschriftSchrifteffekte,

      logo,
      breiteLogo,
      platzierungLogo,
      kopfzeileText,
      kopfzeileTextGroesse,
      kopfzeileTextFarbe,
      kopfzeilePositionierung,

      formularHintergrundfarbe,
      formularRandPosition,
      formularRandStaerke,
      formularRandRadius,
      formularRandFarbe,
      formElementSpacing,

      tabelleUmrandung,
      tabelleUmrandungStaerke,
      tabelleUmrandungFarbe,
      tabelleHintergrundFarbe,
      tabelleKopfzeileEffekte,
      tabelleKopfzeileSchriftFarbe,
      tabelleKopfHintergrundFarbe,

      fusszeileSpaltenlayout,
      fusszeileTexte,
      footerContent,
      fusszeileNummerierung,
      fusszeileTexteGroesse,
      fusszeileTexteFarbe
    );
  }

  toJSON() {
    return {
      layout: this.layout,
      ueberschriftSchriftgroesse: this.ueberschriftSchriftgroesse,
      textSchriftgroesse: this.textSchriftgroesse,
      ueberschriftSchriftart: this.ueberschriftSchriftart,
      textSchriftart: this.textSchriftart,
      abstandOben: this.abstandOben,
      abstandUnten: this.abstandUnten,
      abstandRechts: this.abstandRechts,
      abstandLinks: this.abstandLinks,
      abstandAbsatz: this.abstandAbsatz,
      textAusrichtung: this.textAusrichtung,
      abstandVorUeberschrift: this.abstandVorUeberschrift,
      columnGap: this.columnGap,
      textSchriftFarbe: this.textSchriftFarbe,
      ueberschriftSchriftFarbe: this.ueberschriftSchriftFarbe,
      ueberschriftHintergrundFarbe: this.ueberschriftHintergrundFarbe,
      ueberschriftAbstand: this.ueberschriftAbstand,
      ueberschriftUnterstrichFarbe: this.ueberschriftUnterstrichFarbe,
      ueberschriftUnterstrichStaerke: this.ueberschriftUnterstrichStaerke,
      ueberschriftAusrichtung: this.ueberschriftAusrichtung,
      ueberschriftSchrifteffekte: this.ueberschriftSchrifteffekte,

      logo: this.logo,
      breiteLogo: this.breiteLogo,
      platzierungLogo: this.platzierungLogo,
      kopfzeileText: this.kopfzeileText,
      kopfzeileTextGroesse: this.kopfzeileTextGroesse,
      kopfzeileTextFarbe: this.kopfzeileTextFarbe,
      kopfzeilePositionierung: this.kopfzeilePositionierung,

      formularHintergrundfarbe: this.formularHintergrundfarbe,
      formularRandPosition: this.formularRandPosition,
      formularRandStaerke: this.formularRandStaerke,
      formularRandRadius: this.formularRandRadius,
      formularRandFarbe: this.formularRandFarbe,
      formElementSpacing: this.formElementSpacing,

      tabelleUmrandung: this.tabelleUmrandung,
      tabelleUmrandungStaerke: this.tabelleUmrandungStaerke,
      tabelleUmrandungFarbe: this.tabelleUmrandungFarbe,
      tabelleHintergrundFarbe: this.tabelleHintergrundFarbe,
      tabelleKopfzeileEffekte: this.tabelleKopfzeileEffekte,
      tabelleKopfzeileSchriftFarbe: this.tabelleKopfzeileSchriftFarbe,
      tabelleKopfHintergrundFarbe: this.tabelleKopfHintergrundFarbe,

      fusszeileSpaltenlayout: this.fusszeileSpaltenlayout,
      fusszeileTexte: this.fusszeileTexte,
      footerContent: this.footerContent,
      fusszeileNummerierung: this.fusszeileNummerierung,
      fusszeileTexteGroesse: this.fusszeileTexteGroesse,
      fusszeileTexteFarbe: this.fusszeileTexteFarbe
    };
  }
}
